// extracted by css-extract-rspack-plugin
export default {"PreviewButton":"PreviewQueryButton-module__PreviewButton___toyyU","PreviewButtonIcon":"PreviewQueryButton-module__PreviewButtonIcon___gwRWw"};